export default __webpack_public_path__ + "static/2085-4e95b1bb3a55099dfb5562f3e2d49089.gif";